import { FilterAlt } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useEffect, useState } from "react";

import { defaultFilter } from "./constants";
import { FilterActions } from "./styles";
import { Filters, IFilterHeaderProps } from "./types";

export function FilterHeader({
    handleSearch,
    currentFilter,
}: IFilterHeaderProps) {
    const [filter, setFilter] = useState<Filters>(
        currentFilter ?? defaultFilter
    );

    useEffect(() => {
        if (currentFilter) {
            setFilter(currentFilter);
        }
    }, [currentFilter]);

    return (
        <FilterActions>
            <Button
                variant="contained"
                color="primary"
                onClick={() => handleSearch(filter)}
            >
                Filtrar <FilterAlt />
            </Button>
        </FilterActions>
    );
}
